import styled, { css } from 'styled-components';

export const ScrollContainer = styled.div<{ $scrollAuto: boolean }>`
  container-name: goal-list;
  container-type: inline-size;

  ${({ $scrollAuto }) =>
    $scrollAuto &&
    css`
      height: 100%;
      overflow: auto;
    `};
`;
